module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/umd-4.vue");


//////////////////
// WEBPACK FOOTER
// ./en/umd.md
// module id = 620
// module chunks = 390